import React from "react";

const Help = ({ onClickHelp }) => {
  return (
    <div className="border-y-2 w-auto bg-red-100">
      Tu dois sélectionner les cartes nombres associées aux cartes unités puis
      indiquer une réponse avant de vérifier.
      <div
        className=" text-blue-500 hover:text-blue-900 hover:cursor-pointer"
        onClick={onClickHelp}
      >
        fermer
      </div>
    </div>
  );
};

export default Help;
